module.exports = __webpack_public_path__ + "img/fish.060d989c.png";